// contexts/OnlineStatusContext.js

import React, { createContext, useEffect, useState, useContext, useRef } from 'react';

const OnlineStatusContext = createContext();

export const OnlineStatusProvider = ({ children }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const debounceTimeoutRef = useRef(null);

  useEffect(() => {
    const handleOnline = () => {
      clearTimeout(debounceTimeoutRef.current);
      debounceTimeoutRef.current = setTimeout(() => {
        console.log('[OnlineStatusContext] Debounced online');
        setIsOnline(true);
      }, 500); // debounce delay
    };

    const handleOffline = () => {
      clearTimeout(debounceTimeoutRef.current);
      debounceTimeoutRef.current = setTimeout(() => {
        console.log('[OnlineStatusContext] Debounced offline');
        setIsOnline(false);
      }, 500); // debounce delay
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      clearTimeout(debounceTimeoutRef.current);
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <OnlineStatusContext.Provider value={{ isOnline }}>
      {children}
    </OnlineStatusContext.Provider>
  );
};

export const useOnlineStatus = () => useContext(OnlineStatusContext);
